// --------------------------------------------------------------------------
// testimonialSlider.js
// --------------------------------------------------------------------------
// Slick.js carousel for testimonial slider
// --------------------------------------------------------------------------

EC.testimonialSlider = function () {

    'use strict';

    function init () {
        const $slider = $('.js-testimonial-slider');

        if($slider.length > 0){
            $slider.slick({
                prevArrow: buttonHtml('prev'),
                nextArrow: buttonHtml('next'),
                dots: true
            });
        }
    }

    function buttonHtml (direction) {
        return `<button class="b-testimonial-slider__control b-testimonial-slider__control--${direction}" aria-label="Go to ${direction}">
                    <svg class="b-testimonial-slider__arrow" role="presentation">
                      <use xlink:href="#icon-arrow"></use>
                    </svg>
                </button>`;
    }

    return {
        init: init
    };

}();
